const TargetOptionType = {
  Question: 1,
  Form: 2
};

export default TargetOptionType;
